import React, { useState } from "react";
import { connect } from "react-redux";
import { GetSKUReportApi } from "./Report.action";
import { Link } from "react-router-dom";
import { CalendarIcon, DownloadIcon, ChevronRightIcon } from "../../../components/Icons";
import _ from "lodash";
import Swal from "sweetalert";
import moment from "moment";
import SinglePageDashboard from "../../../drawer/SinglePageDashbord";
import GlobalFormCard from "../../../components/GlobalFormCard";
import DateField from "../../../components/DateField";
import "./Report.css";


const SKUReport = (props) => {
    const [startDate, setStartDate] = useState(moment().startOf("month").format("YYYY-MM-DD"));
    const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
    const isDisabled = _.isEmpty(startDate) || _.isEmpty(endDate) || props.isFetchingSKUReport;

    const handleDangerVisible = (msg) => {
        Swal({
            title: "Error",
            text: msg || "Something went wrong!",
            icon: "error",
            button: "Ok",
        });
    };

    const generateReport = () => {
        props.GetSKUReportApi(
            { startDate, endDate },
            handleDangerVisible,
        );
    };

    return (
        <>
            <SinglePageDashboard header="SKU Report" />

            <div className="page-container">
                <div className="breadcrumb">
                    <Link to="/home" className="breadcrumb-link">Home</Link>
                    <ChevronRightIcon />
                    <Link to="/report" className="breadcrumb-link">Reports</Link>
                    <ChevronRightIcon />
                    <span className="breadcrumb-current">SKU Report</span>
                </div>

                <div className="page-header">
                    <h1 className="page-title">SKU Report</h1>
                </div>

                <GlobalFormCard
                    title="Select Date Range"
                    subtitle="Report will be generated for the selected period"
                    icon={<CalendarIcon />}
                    maxWidth="900px"
                >
                    <DateField
                        label="Start Date"
                        value={startDate}
                        onChange={setStartDate}
                    />
                    <DateField
                        label="End Date"
                        value={endDate}
                        onChange={setEndDate}
                    />

                    <div className="divider" />

                    <button
                        onClick={generateReport}
                        disabled={isDisabled}
                        className={`generate-btn ${isDisabled ? "disabled" : ""}`}
                    >
                        {props.isFetchingSKUReport ? (
                            <>
                                <span className="spinner" />
                                Generating…
                            </>
                        ) : (
                            <>
                                <DownloadIcon />
                                Generate Report
                            </>
                        )}
                    </button>

                    <p className="footer-text">
                        Report shows product-wise sale qty, purchase qty, average prices and profit
                    </p>
                </GlobalFormCard>
            </div>
        </>
    );
};

const mapDispatchToProps = (dispatch) => ({
    GetSKUReportApi: (payload, handleDangerVisible) =>
        dispatch(GetSKUReportApi(payload, handleDangerVisible)),
});

const mapStateToProps = (state) => ({
    isFetchingSKUReport: state.ReportReducer.isFetchingSKUReport,
    skuReportData: state.ReportReducer.skuReportData,
});

export default connect(mapStateToProps, mapDispatchToProps)(SKUReport);
